// YouTube動画をモーダル（dialog）で再生する。
// クリックされるまで再生画面（iframe）は読み込まず、閉じたら取り除いて再生を止める。
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "player"]
  static values = { embedUrl: String }

  // サムネイル（リンク）のクリック: YouTubeへの遷移を止めてモーダルで開く
  open(event) {
    event.preventDefault()
    if (this.dialogTarget.open) return

    this.playerTarget.replaceChildren(this.buildIframe())
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
  }

  // 背景（dialog自身）のクリックで閉じる。動画側のクリックは対象外
  backdropClick(event) {
    if (event.target === this.dialogTarget) this.close()
  }

  // dialogが閉じたとき（閉じるボタン・Esc・背景クリック共通）に再生画面を取り除く
  closed() {
    this.playerTarget.replaceChildren()
  }

  // Turboのキャッシュ前・ページ移動時にモーダルと再生画面を後片付けする
  reset() {
    if (!this.hasDialogTarget) return

    if (this.dialogTarget.open) this.dialogTarget.close()
    this.playerTarget.replaceChildren()
  }

  disconnect() {
    this.reset()
  }

  buildIframe() {
    const iframe = document.createElement("iframe")
    iframe.src = this.embedUrlValue
    iframe.title = "YouTube動画"
    iframe.allow = "autoplay; encrypted-media; picture-in-picture; fullscreen"
    iframe.allowFullscreen = true
    iframe.referrerPolicy = "strict-origin-when-cross-origin"
    return iframe
  }
}
